import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function ProtectedRoute({ children, adminOnly = true }) {
  const { user, isAdmin } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return <div className="min-h-screen bg-[#050505] flex items-center justify-center text-ink-500 text-[11px] tracking-[0.24em] uppercase" data-testid="auth-loading">Checking session…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  if (adminOnly && !isAdmin) return <Navigate to="/admin/login" replace />;
  return children;
}
